export const resolveIosDeepLink = (url: string, applicationId: string): string => {
    const DEFAULT_SCHEME = 'alfabank://';
    const EMPTY_APP_ID_IOS_LENGTH = 8; // Минимальная длина названия app ios для парсинга

    if (!applicationId) {
        return url;
    }

    const validApplicationId = applicationId && applicationId.length > EMPTY_APP_ID_IOS_LENGTH;

    // каждый applicationId, в формате com.{appId}.app, где appId === scheme
    const newApplcationName = applicationId.substring(4, applicationId.length - 4);
    const newScheme = validApplicationId ? newApplcationName : 'alfabank';

    return url.replace(DEFAULT_SCHEME, `${newScheme}://`);
};

export const getMobileAppIdForIosVersion = (version: string, mobileAppId: string): string => {
    const appVersion = version?.replace(/\.[^.]*$/, '');

    if (appVersion === '12.22') {
        return 'com.aconcierge.app';
    }

    if (appVersion === '12.26') {
        return 'com.kittycash.app';
    }

    return mobileAppId;
};
